import * as React from 'react';

/**
 * Table density, provided by <Table> and read by its cells. Separate file so
 * table.tsx exports only components (react-refresh constraint) — same reason
 * buttonVariants.ts exists.
 */

export type TableDensity = 'dense' | 'compact';

export const DensityContext = React.createContext<TableDensity>('dense');

/** Current table density — for cells (e.g. EmptyStateCell) rendered inside a <Table>. */
export function useTableDensity(): TableDensity {
  return React.useContext(DensityContext);
}
